// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-xxcj-pictureswall-index-main_right_content-yop3d","table":"components-xxcj-pictureswall-index-table-iTAFX"};


//////////////////
// WEBPACK FOOTER
// ./components/xxcj/pictureswall/index.css
// module id = 2327
// module chunks = 0